import type { ReactNode } from 'react';

type Props = {
  title: string;
  children?: ReactNode;
};

export const SegmentContainer = ({ title, children }: Props) => {
  return (
    <div>
      <h2 className="text-2xl leading-7 text-[#09090B] font-semibold mb-4 xl:mb-6 xl:text-[2rem] xl:leading-10">
        {title}
      </h2>
      <div className="mb-8 xl:mb-14">{children}</div>
    </div>
  );
};
